/**
 * Builds the API request action payload for the AI-guided configuration flow.
 *
 * When `selectedInbox.inboxID` exists we are editing an existing dataset (Modify
 * API Connection), so the action becomes `saveAPIInbox` and we forward the
 * existing inbox's flags. Otherwise we are creating a brand-new dataset.
 */
export const buildAutoConfigAction = (
    config,
    { connectorType, connectionKey, workspaceID, selectedInbox }
) => {
    const extractDefinition = {
        connectorType,
        // For connectors that expose a real object list (e.g. GA4, where the
        // object is the Property), config.object holds the one the user picked
        // or that was auto-selected. The AI presets only carry a generic
        // placeholder, so when a real object is available it must win.
        object: config.object || { name: config.objectName, label: config.objectLabel },
        fields: config.fieldNames.map((name, i) => ({
            name,
            label: config.fieldLabels[i],
        })),
        filters: config.filters || [],
    }

    if (config.dateRange?.start) {
        extractDefinition.startDate = config.dateRange.start
    }

    const isEdit = !!(selectedInbox && selectedInbox.inboxID)

    const action = {
        connectionKey,
        workspaceID,
        datasetName: config.datasetName,
        extractDefinition,
        extractNow: true,
        snapshot: isEdit ? selectedInbox.isSnapshot === 'Snapshot' : false,
    }

    if (isEdit) {
        action.action = 'saveAPIInbox'
        action.inboxID = selectedInbox.inboxID
        action.isMostRecent = selectedInbox.isMostRecent
        action.isIncremental = selectedInbox.isIncremental
        action.isMultipleLoads = selectedInbox.isMultipleLoads
    } else {
        action.action = 'createAPIInbox'
    }

    return action
}
